import {Controller, Context} from '@hotwired/stimulus';
import ReactDOM from "react-dom/client";
import React from "react";
import Debug from 'debug';

const debug = Debug('app:ReactWrapperController');

export class ReactWrapperController extends Controller<HTMLDivElement> {

    static values = {
        props: {type: String},
    }

    declare propsValue: string;
    declare hasPropsValue: boolean;
    declare reactRoot: any;

    constructor(context: Context, private componentFactory: (props: any) => React.ReactElement, private props?: {permanent?: boolean}) {
        super(context);
    }

    connect() {
        if (this.reactRoot && this.props?.permanent) {
            return;
        }

        this.reactRoot = ReactDOM.createRoot(this.element);
        const rawProps = this.resolveProps();
        debug('Resolved props', rawProps);

        this.reactRoot.render(this.componentFactory(JSON.parse(rawProps)));


        setTimeout(() => {
            const contentHeight = this.element.scrollHeight;
            this.element.style.height = `${contentHeight}px`;
            this.element.classList.remove('opacity-0')
            this.element.classList.add('opacity-100')
            debug('set height to', contentHeight);

            // Listen for the transition to finish
            this.element.addEventListener('transitionend', this.setHeightAuto, { once: true });
        }, 100)

    }

    setHeightAuto = () => {
        debug('setting height to auto');
        // This removes the inline height, allowing the element to grow/shrink naturally
        this.element.style.height = 'auto';
    }


    private resolveProps(): string {
        let raw = this.hasPropsValue ? this.propsValue : null;

        if (!raw) {
            raw = this.element.getAttribute("data-props");
            debug('data-props=', raw)
        }

        if (!raw) {
            return '{}'
        }

        return raw;
    }


    disconnect() {
        if (this.reactRoot && !this.props?.permanent) {
            this.reactRoot.unmount();
        }
        this.element.style.removeProperty('height');
        this.element.removeEventListener('transitionend', this.setHeightAuto);
    }
}